module.exports = __webpack_public_path__ + "static/media/flyer-icon.c582acd6.svg";